/*
  Stijlgids-kaarten: klikken op een swatch wisselt het sfeerbeeld, de kleurnaam
  en de link van de knop naar de bijbehorende set.

  Beide beelden staan al in de DOM en worden met een klasse getoond of verborgen.
  Dat is bewust: src omwisselen geeft een witte flits omdat de browser het nieuwe
  beeld pas dan gaat laden. Het tweede beeld heeft loading="lazy", dus het kost
  niets tot de kaart in beeld komt.
*/
(function () {
  function initCard(card) {
    var swatches = card.querySelectorAll('[data-cg-swatch]');
    if (swatches.length < 2) return;

    var images = card.querySelectorAll('[data-cg-image]');
    var naam = card.querySelector('[data-cg-name]');
    var cta = card.querySelector('[data-cg-cta]');

    function activate(index) {
      swatches.forEach(function (s) {
        var on = s.getAttribute('data-cg-swatch') === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      images.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-cg-image') === index);
      });
      var bron = card.querySelector('[data-cg-swatch="' + index + '"]');
      if (!bron) return;
      if (naam) naam.textContent = bron.getAttribute('data-cg-label') || '';
      if (cta) {
        var url = bron.getAttribute('data-cg-url');
        if (url) cta.setAttribute('href', url);
      }
    }

    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        activate(s.getAttribute('data-cg-swatch'));
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-cg-card]').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // De theme editor bouwt een sectie opnieuw op zonder de pagina te herladen.
  document.addEventListener('shopify:section:load', init);
})();
